import {Title} from "#app/interface/cabinet/header/Dropdown/styles";
import Dropdown from "#app/interface/cabinet/header/Dropdown/Dropdown";
import React from "react";
import SmallProfileImage from "#app/components/ProfileImage/SmallProfileImage";
import useLogout from "#app/hooks/useLogout";


const ProfileDropdown = ({ i18n, data, handleMenu, logout }) => {
  const handleLogout = useLogout(logout);

  const menuLinks = [
    { id: 'avatar-menu-0', link: '/cabinet/register/page1', text: i18n.menu.profile },
    { id: 'avatar-menu-1', link: '/cabinet/logout', onClick: handleLogout, text: i18n.menu.logout }
  ];

  return (
    <Dropdown
      id="dropdown-profile"
      links={menuLinks}
    >
      <Title>
        <SmallProfileImage />
      </Title>
    </Dropdown>
  );
};

export default ProfileDropdown;